module.exports = __webpack_public_path__ + "static/media/SuppliersUnrelatedItemsIcon.535e55e0.svg";